export const GET_PLC_SAFETY_ZONES = 'GET_PLC_SAFETY_ZONES';
export const GET_PLC_SAFETY_ZONES_SUCCESS = 'GET_PLC_SAFETY_ZONES_SUCCESS';
export const GET_PLC_SAFETY_ZONES_ERROR = 'GET_PLC_SAFETY_ZONES_ERROR';
